import { createAction, props } from '@ngrx/store';

import { type CanvasElementId, type SlotId } from '@blaze-runtime/engine-domain';
import { type RenderElementDataRowContext } from '@blaze-shared/elements-domain';

export const elementSelect = createAction(
  '[Canvas] Element select',
  props<{
    elementId: CanvasElementId;
    slotId?: SlotId;
    rowContext?: RenderElementDataRowContext;
  }>(),
);

export const elementMouseDown = createAction(
  '[Canvas] Element mouse down',
  props<{
    mouseDownEvent: MouseEvent;
    elementId: CanvasElementId;
    slotId?: SlotId;
    rowContext?: RenderElementDataRowContext;
  }>(),
);
